import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import { CHECKOUT_EVENTS } from './../../constants';
import { cancelCheckout, cancelHoldSpot, confirmCheckout, confirmUnreserve, confirmTradeSpot, afterCheckoutCloseButtonClick } from './../../actions/checkout';
import SpotReservationNotice from '../../components/SpotReservationNotice';


const isHold = event => (event === CHECKOUT_EVENTS.hold);
const isUnreserve = event => (event === CHECKOUT_EVENTS.unreserve);
const isTrade = event => (event === CHECKOUT_EVENTS.trade);

class CheckoutActions extends Component {

  constructor (props) {
    super(props);
    this.handleCancelCheckout = this.handleCancelCheckout.bind(this);
    this.handleCloseCheckout = this.handleCloseCheckout.bind(this);
    this.handleConfirmCheckout = this.handleConfirmCheckout.bind(this);
  }

  handleCancelCheckout () {
    const {event, spotToReserve, cancelHoldSpot, cancelCheckout, isInValidTimer} = this.props;
    ( isHold(event) && !isInValidTimer ) ? cancelHoldSpot(spotToReserve) : cancelCheckout();
  }

  handleCloseCheckout () {
    this.props.afterCheckoutCloseButtonClick();
  }

  handleConfirmCheckout () {
    const {event, spotToUnreserve, confirmUnreserve, confirmTradeSpot, confirmCheckout} = this.props;
    if(isUnreserve(event)){
      return confirmUnreserve(spotToUnreserve);
    }
    if(isTrade(event)){
      return confirmTradeSpot();
    }
    return confirmCheckout();
  }

  render() {
    const { event, isInValidTimer, hideConfirmButton, disableConfirmButton } = this.props;
    const confirmButtonText = isUnreserve(event) ? 'Yes, remove this spot' : 'Confirm my spot';
    let confirmButtonClassName = `btn btn-lg btn-block ${ isUnreserve(event) ? "btn-danger" : "btn-success" }`;
    const helpText = isUnreserve(event) ? 'You can reserve another spot later if you change your mind' : 'You can change your mind later if you need.';
    const showConfirmButton = !hideConfirmButton && !disableConfirmButton;

    if(isInValidTimer) {
      return(
        <div className="map-page-content-footer">
          <p>
            <a className="btn btn-default btn-lg btn-block" onClick={this.handleCloseCheckout}>Close</a>
          </p>
        </div>
      );
    }

    return(
      <div className="map-page-content-footer">
        <p>
          <a className="btn btn-default btn-lg btn-block" onClick={this.handleCancelCheckout}>Cancel</a>
          {showConfirmButton &&
            <a className={confirmButtonClassName} onClick={this.handleConfirmCheckout} >{confirmButtonText}</a>}
        </p>
        <p className="text-center">{helpText}</p>
        <SpotReservationNotice />
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  const { event } = state.checkout;
  const { attendee } = state.userAccommodationInfo;
  return {
    event,
    attendee
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({cancelCheckout, cancelHoldSpot, confirmCheckout, confirmUnreserve, confirmTradeSpot, afterCheckoutCloseButtonClick }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutActions);



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutActions.js